import { Spin } from 'antd';
import React from 'react';
import { observer } from 'mobx-react';

import AMATimeUnitModifyStore from './Store';
import AMATimeUnitModifyTable from './Table';
import AMATimeUnitModifyToolbar from './Toolbar';
import AMATimeUnitModifyModal from './Modal';
import dashboardStore from '@stores/dashboard';
import * as api from '@stores/api';

@observer
class AMATimeUnitModify extends React.Component {
  componentDidMount() {
    if (!api.isAdminOrMagStaffOrAccounting()) {
      dashboardStore.close('/view/modify-unit', true);
      return;
    }
    AMATimeUnitModifyStore.fetchData(true);
  }
  render() {
    const { data, loading, open } = AMATimeUnitModifyStore;
    return (
      <div className={`Table-${loading && !data ? 'loading' : 'container'}`}>
        {loading && !data ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <AMATimeUnitModifyToolbar />
            <AMATimeUnitModifyTable />
            {open && <AMATimeUnitModifyModal />}
          </React.Fragment>
        )}
      </div>
    );
  }
}
export default AMATimeUnitModify;
